import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { Http, ConnectionBackend, RequestOptions, RequestOptionsArgs, Request, Response, ResponseOptions, Headers } from '@angular/http';

import { authHttpKey, authHttpPrefix } from './authorization.const';
import { AuthHttpConfig } from './auth-http-config';

@Injectable()
export class AuthHttpService extends Http {

  public static getTokenHeaderName(): string {
    return authHttpKey;
  }

  public onAccessDenied: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private authHttpConfig: AuthHttpConfig,
    connectionBackend: ConnectionBackend,
    requestOptions: RequestOptions
  ) {
    super(connectionBackend, requestOptions);
  }

  public setToken(token: string) {
    this.authHttpConfig.setToken(token);
  }

  public getPrefixedToken(): string {
    return authHttpPrefix + this.authHttpConfig.getToken();
  }

  public getToken(): string {
    return this.authHttpConfig.getToken();
  }

  public removeToken() {
    this.authHttpConfig.removeToken();
  }

  public request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
    if (null === this.authHttpConfig.getToken()) {
      return Observable
        .throw(new Response(new ResponseOptions({ status: 403 })))
        .catch((response: Response) => this.handleAuthError(response));
    }

    this.assignAuthorizationToken(url, options);

    return super.request(url, options)
      .catch((response: Response) => this.handleAuthError(response));
  }

  private assignAuthorizationToken(url: string | Request, options?: RequestOptionsArgs): void {
    if (url instanceof Request) {
      this.setHeaders(url.headers);

      return;
    }

    if (!options) {
      options = {
        headers: new Headers()
      };
    }

    this.setHeaders(options.headers);
  }

  private setHeaders(headers: Headers) {
    headers.set(authHttpKey, this.getPrefixedToken());
  }

  private handleAuthError(response: Response) {
    if (response.status === 401 || response.status === 403) {
      this.onAccessDenied.emit(response);
    }

    return Observable.throw(response);
  }
}



// WEBPACK FOOTER //
// /dist/src/app/security/authorization/auth-http.service.ts